import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-slider-slide",
    styleUrl: "slider-slide.scss",
    shadow: false
})
export class Slide {
    /** label of the slide */
    @Prop() readonly label: string = "";

    render() {
        return (
            <Host class="ux-slider-slide">
                <slot />
            </Host>
        );
    }
}
